/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 10:43 am
 * Last Modified: Monday, 24-10-28 09:06 pm, by Harper Yan
 */

import {
  BottomNavigation,
  BottomNavigationAction,
  bottomNavigationActionClasses,
  styled,
} from '@mui/material';

export const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  alignSelf: 'center',
  position: 'absolute',
  display: 'flex',
  padding: '12px 58px',
  justifyContent: 'space-between',
  borderRadius: '100px',
  background: '#2B2C3A',
  boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.12)',
  height: 'auto',
  zIndex: 100,
  bottom: '20px',

  [theme.breakpoints.only('xs')]: {
    bottom: '50px',
  },
}));

export const StyledBottomNavigationAction = styled(BottomNavigationAction)(
  () => ({
    [`&.${bottomNavigationActionClasses.selected}`]: {
      color: 'white',
      [`& .${bottomNavigationActionClasses.label}`]: {
        fontSize: '0.75rem',
      },
    },
  }),
);
